"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "es": {
        "translation": {
            "page_header": {
                "example": "Ejemplo",
                "icons": {
                    "academy": "Academia",
                    "asset_inventory": "Inventario de activos",
                    "assets_and_attributes": "Activos y atributos",
                    "assurance_plans": "Planes de aseguramiento",
                    "bulk_importer": "Importador de forma masiva",
                    "compliance_maps": "Mapas de cumplimiento",
                    "community": "Comunidad",
                    "frameworks": "Marcos",
                    "issue_tracker": "Rastreador de asuntos",
                    "launchpad": "Launchpad",
                    "mission_control": "Control de la misión",
                    "projects": "Proyectos",
                    "reports": "Reportes",
                    "results": "Resultados",
                    "robots": "Robots",
                    "scheduler": "Programador",
                    "storyboard": "Storyboards",
                    "strategy": "Estrategia",
                    "task_tracker": "Rastreador de tareas",
                    "time_sheets": "Planillas de horas",
                    "toolkits": "Juegos de herramientas"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=es.js.map